export const preventionGroup = {
    'meta': {
        'title': 'Grupa rozwojowa dla młodzieży 15-18 lat #cityLocativeIn#',
        'description': 'Psychoterapia grupowa pozwala na rozwinięcie funkcjonowania w relacjach grupowych oraz rozwój zdolności w oparciu o relację z innymi ludźmi.'
    },
    'availability': [
        'torun'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/grupa-terapeutyczno-rozwojowa-dla-mlodziezy/',
        'title': 'Grupa terapeutyczno-rozwojowa dla młodzieży #cityLocativeIn#',
        'name': 'Grupa terapeutyczno-rozwojowa dla młodzieży #cityLocativeIn#',
        'heading': 'Grupa terapeutyczno-rozwojowa dla młodzieży #cityLocativeIn#',
        'fullName': 'Grupa terapeutyczno-rozwojowa dla młodzieży'
    },
    'image': {
        'url': '/images/services/grupa-terapeutyczno-rozwojowa-mlodziezy.webp',
        'width': 840,
        'height': 321,
        'alt': 'Grupa terapeutyczno-rozwojowa dla młodzieży #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/open-graph/grupa-terapeutyczno-rozwojowa-mlodziezy.jpg',
            'width': 840,
            'height': 321,
            'alt': 'Grupa terapeutyczno-rozwojowa dla mlodzieży #cityLocativeIn#'
        }
    }
}